import { render, staticRenderFns } from "./OrderStockIndicator.vue?vue&type=template&id=2af316f9&scoped=true&"
import script from "./OrderStockIndicator.vue?vue&type=script&lang=js&"
export * from "./OrderStockIndicator.vue?vue&type=script&lang=js&"
import style0 from "./OrderStockIndicator.vue?vue&type=style&index=0&id=2af316f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af316f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
